export enum InfrastructureTypeEnum {
    /**
     * Unknown infrastructure type.
     */
    INFRST_UNKNOWN = 'INFRST_UNKNOWN',
    /**
     * Airport infrastructure.
     */
    INFRST_AIRPORT = 'INFRST_AIRPORT',
    /**
     * Heliport infrastructure.
     */
    INFRST_HELIPORT = 'INFRST_HELIPORT',
    /**
     * Aerodrome infrastructure.
     */
    INFRST_AERODROME = 'INFRST_AERODROME',
    /**
     * Airfield infrastructure.
     */
    INFRST_AIRFIELD = 'INFRST_AIRFIELD',
    /**
     * Natural park infrastructure.
     */
    INFRST_NAT_PARK = 'INFRST_NAT_PARK',
    /**
     * Harbor infrastructure.
     */
    INFRST_HARBOUR = 'INFRST_HARBOUR',

    /**
     * Railway/Road infrastructure.
     */
    INFRST_NET_TRACK = 'INFRST_NET_TRACK',
}